import ProgressWidget from 'src/pages/Achievements/subcomponents/ProgressWidget/ProgressWidget'
export default ProgressWidget
